// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:22:33

export default {
  "id": "code-maze",
  "slug": "code-maze",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/17f5d1c95d6c4726be779e22b1c46a8e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/17f5d1c95d6c4726be779e22b1c46a8e/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Code Maze",
      "description": "Master programming logic with Code Maze! Use code blocks to navigate mazes, overcome obstacles, and reach goals. Each level challenges your problem-solving skills. Ready to code your way out?",
      "instructions": "Drag code blocks to guide your avatar through the maze. Use moves, loops, and conditionals to reach the goal efficiently. Fewer blocks mean higher scores. Test, retry, and conquer each level!",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "computer",
        "levels",
        "logic",
        "logical",
        "student"
      ]
    },
    "zh-CN": {
      "title": "代码迷宫",
      "description": "掌握编程逻辑，挑战《代码迷宫》！使用代码块穿越迷宫，克服障碍，达成目标。每个关卡都考验你的解决问题的能力。准备好用代码走出迷宫了吗？",
      "instructions": "将代码块拖动以引导你的角色穿越迷宫。使用移动、循环和条件语句高效地达到目标。代码块越少，得分越高。测试、重试并征服每个关卡！",
      "genres": [
        "拼图"
      ],
      "tags": [
        "电脑",
        "关卡",
        "逻辑",
        "逻辑的",
        "学生"
      ]
    },
    "zh-TW": {
      "title": "代碼迷宮",
      "description": "以Code Maze精進程式邏輯！使用程式塊穿梭迷宮，克服障礙，達成目標。每關挑戰你的問題解決能力。準備透過編程脫困了嗎？",
      "instructions": "將程式碼塊拖動以引導你的角色通過迷宮。使用移動、迴圈和條件判斷有效地達到目標。塊數越少得分越高。測試、重試並征服每一關！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "電腦",
        "等級",
        "邏輯",
        "邏輯的",
        "學生"
      ]
    },
    "zh-HK": {
      "title": "編碼迷宮",
      "description": "透過Code Maze精通編程邏輯！使用程式塊在迷宮中尋路，克服障礙，達成目標。每個關卡挑戰你的解題技巧。準備好用程式編寫出路徑了嗎？",
      "instructions": "將程式塊拖移以引導你的角色穿越迷宮。使用移動、循環及條件判斷來高效達成目標。塊數越少得分越高。測試、重試並征服每一關！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "電腦",
        "關卡",
        "邏輯",
        "邏輯學",
        "學生"
      ]
    },
    "ja": {
      "title": "コード・メイズ",
      "description": "コードマゼーでプログラミングの論理をマスター！コードブロックを使って迷路を進み、障害を乗り越え、ゴールに達する。各レベルで問題解決スキルを試されます。コードで脱出する準備はできましたか？",
      "instructions": "コードブロックをドラッグしてあなたのアバターより迷路を導いてください。移動、ループ、条件を使って効率的にゴールに達しましょう。ブロックが少ないほど得点が高くなります。テストし、再試行し、各レベルを征服しましょう！",
      "genres": [
        "パズル"
      ],
      "tags": [
        "コンピュータ",
        "レベル",
        "論理",
        "論理的",
        "学生"
      ]
    },
    "ko": {
      "title": "코드 메이즈",
      "description": "코드 메이즈를 통해 프로그래밍 로직을 마스터하세요! 코드 블록을 사용하여 루브리크를 돌아다니고 장애물을 극복하며 목표지점에 도달하세요. 각 레벨은 문제 해결 능력을 도전합니다. 코드로 탈출할 준비가 되셨나요?",
      "instructions": "드래그 코드 블록을 통해 아바타를 미로를 통해 안내하세요. 목적지에 효율적으로 도달하기 위해 이동, 루프, 조건을 사용하세요. 블록이 적을수록 높은 점수입니다. 테스트하고, 재시도하고, 각 레벨을 통과하세요!",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "컴퓨터",
        "레벨",
        "논리",
        "논리적",
        "학생"
      ]
    },
    "fr": {
      "title": "Labyrinthe du Code",
      "description": "Maîtrisez la logique de programmation avec Code Maze ! Utilisez des blocs de code pour naviguer dans les labyrinthes, surmonter les obstacles et atteindre les objectifs. Chaque niveau challenge vos compétences en résolution de problèmes. Prêt à coder votre chemin pour vous en sortir ?",
      "instructions": "Déplacez les blocs de code pour guider votre avatar à travers le labyrinthe. Utilisez les mouvements, les boucles et les conditions pour atteindre l'objectif de manière efficace. Moins de blocs signifie des scores plus élevés. Testez, réessayez et conquérez chaque niveau !",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "ordinateur",
        "niveaux",
        "logique",
        "logique",
        "étudiant"
      ]
    }
  }
};
